import { DetailedSourceLanguageResponse } from 'src/types/languagesDomain';
import { toCamelCaseDeep } from 'src/utils/transform';
import * as ApiSchema from './schema';

export function toDetailedSourceLanguage(
  response: ApiSchema.SourceLanguageResponse,
): DetailedSourceLanguageResponse {
  return toCamelCaseDeep(response);
}

export function toDetailedSourceLanguages(
  response: ApiSchema.SourceLanguagesResponse,
): DetailedSourceLanguageResponse[] {
  return response.map(toDetailedSourceLanguage);
}
